import { getObjValue } from 'utils/functions';
import { createSelector } from 'reselect';

const getIdFromUrlParams = props => getObjValue(props, 'match.params.id', null);
const getDomainRestrictedTemplates = props => getObjValue(props, 'domainRestrictedTemplates.getDomainRestrictedTemplates', []);
export const getLangFromUrlParams = props => getObjValue(props, 'match.params.lang', null);
export const isFetchingTemplates = props => getObjValue(props, 'getTemplates.loading', true);
export const isFetchingDomainRestrictedTemplates = props => getObjValue(props, 'getDomainRestrictedTemplates.loading', true);
export const isFetchingSubmittedTemplates = props => getObjValue(props, 'getSubmittedTemplates.loading', true);

export const getTemplatesSelector = props => getObjValue(props, 'getTemplates.getTemplates', []);
export const getDomainRestrictedTemplatesSelector = props => getObjValue(props, 'getDomainRestrictedTemplates.getDomainRestrictedTemplates', []);
export const getSubmittedTemplatesSelector = props => getObjValue(props, 'getSubmittedTemplates.getSubmittedTemplates', []);

const getTemplates = props => getObjValue(props, 'template', null);
const getTemplateFieldActions = props => getObjValue(props, 'actions.fieldActions', []);
const getSectionActions = props => getObjValue(props, 'actions.sectionActions', []);
const getUnansweredFields = createSelector([getTemplates], template => getObjValue(template, 'metadata.unansweredFields', null));

const getTemplateLanguages = props => {
  let templateLanguages = [];
  const templates = getDomainRestrictedTemplates(props);
  if (templates != null) {
    templateLanguages = templates?.filter(data => data.urlGuid === getIdFromUrlParams(props)).map(data => data.translationMetadata);
  }

  return templateLanguages.flatMap(languages => languages);
};

const getTemplateDDERequiredFields = createSelector(
  [getTemplates, getTemplateFieldActions, getSectionActions, getUnansweredFields],
  (template, fieldActions, sectionActions, unansweredFields) => {
    if (template) {
      const hiddenAndReadOnlyFields = unansweredFields?.filter(field =>
        sectionActions?.some(action => action.id === field.categoryId && (action.acl_action === 'Hide' || action.acl_action === 'ReadOnly'))
      );
      const requiredFieldsFromActions = fieldActions?.filter(field =>
        fieldActions?.some(action => action.id === field.id && action.acl_action === 'Required')
      );

      const ddeRequiredFields = requiredFieldsFromActions?.filter(field => !hiddenAndReadOnlyFields?.some(f => field.id === f.id));

      return ddeRequiredFields;
    }
    return [];
  }
);

const hasUnansweredDDERequiredFields = createSelector([getTemplateDDERequiredFields, getUnansweredFields], (ddeRequiredFields, unansweredFields) => {
  return ddeRequiredFields?.some(templateDDEField => unansweredFields.map(f => f.fieldId).includes(templateDDEField.id));
});

export { getTemplates, getUnansweredFields, getTemplateDDERequiredFields, hasUnansweredDDERequiredFields, getTemplateLanguages };
